import { normalize, schema } from 'normalizr';
import { createMemberSchema } from '../../../models/member/member.schema';
import { photoRevealSchema } from '../../../models/photoReveals';
import {
  IApiPhotoRevealsResult,
  IPhotoRevealsNormalized,
} from '../../../models/photoReveals/photoReveals.types';
import { pictureSchema } from '../../../models/picture';
import { memberInPhotoPrivacySerializer } from '../helper';

const photoRevealsSchema = new schema.Object({
  data: [photoRevealSchema],
  included: new schema.Array(
    {
      member: createMemberSchema(memberInPhotoPrivacySerializer),
      mainPicture: pictureSchema,
    },
    'type'
  ),
});

export const photoRevealsNormalizer = (
  photoReveals: IApiPhotoRevealsResult
): IPhotoRevealsNormalized => {
  return normalize(photoReveals, photoRevealsSchema) as IPhotoRevealsNormalized;
};
